import { ModuleWithProviders, NgModule } from '@angular/core';

import { SharedModule } from '../common/shared.module';
import { CustomerRoutingModule } from './customer-routing.module';

import { CustomerBasicInfoComponent } from './customer-basic-info/customer-basic-info.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { CustomersComponent } from './customer-list/customers.component';
import { CustomerHeaderComponent } from './customer-header/customer-header.component';

import { CustomerService } from './customer.service';
import { CustomerContactService } from './shared-entities/customer-contact.service';
import { CustomerHoltContactService } from './shared-entities/customer-holtcontact.service';
import { ContactNotificationTypeService } from '../model/shared-entities/contacts/contact-notification-type.service';
import { MultiselectControlModule } from '@mt-ng2/multiselect-control';
import { CustomerDockLocationsComponent } from './customer-dock-locations/customer-dock-locations.component';
import { CustomerPickUpHourService } from './customerpickuphour.service';
import { CustomerPickupOverrideService } from './customer-pickup-override.service';
import { CustomerPickupOverrideComponent } from './customer-pickup-override/customer-pickup-override.component';
import { CustomerNonTwicTimingComponent } from './customer-non-twic-timing/customer-non-twic-timing.component';
import { CustomerNonTwicTimingService } from './customer-non-twic-timing.service';
import { CustomerModifiedHourService } from './customer-modified-hour.service';

@NgModule({
    declarations: [
        CustomersComponent,
        CustomerHeaderComponent,
        CustomerDetailComponent,
        CustomerBasicInfoComponent,
        CustomerDockLocationsComponent,
        CustomerPickupOverrideComponent,
        CustomerNonTwicTimingComponent,
    ],
    imports: [SharedModule, CustomerRoutingModule, MultiselectControlModule],
})
export class CustomerModule {
    static forRoot(): ModuleWithProviders<CustomerModule> {
        return {
            ngModule: CustomerModule,
            providers: [
                CustomerService,
                CustomerContactService,
                CustomerHoltContactService,
                ContactNotificationTypeService,
                CustomerPickUpHourService,
                CustomerPickupOverrideService,
                CustomerModifiedHourService,
                CustomerNonTwicTimingService,
            ],
        };
    }
}
